import React, { useState } from 'react'
import Switch from '@material-ui/core/Switch'
import { StyleSheet, css } from 'aphrodite'
import { Helper } from '../helpers/Helper'

export function StaffCheckInDialogContent(props) {
  const { submitting, onCheckIn } = props
  const [switchOn, setSwitchOn] = useState(false)

  const handleChange = (e) => {
    if (submitting) return
    if (!e.target.checked) {
      setSwitchOn(false)
      return
    }
    setSwitchOn(true)
    const p = onCheckIn && onCheckIn()
    if (p && typeof p.then === 'function') {
      p.catch(() => setSwitchOn(false))
    }
  }

  return (
    <div className={css(Styles.body)}>
      <p className={css(Styles.message)}>{Helper.getString('staffCheckInDialogMessage')}</p>
      <div className={css(Styles.row)}>
        <span className={css(Styles.label)}>{Helper.getString('staffCheckIn')}</span>
        <Switch
          color='primary'
          checked={switchOn}
          disabled={submitting}
          onChange={handleChange}
        />
      </div>
    </div>
  )
}

const Styles = StyleSheet.create({
  body: {
    padding: '8px 8px 24px',
    maxWidth: 480,
    textAlign: 'center'
  },
  message: {
    color: '#000000',
    fontSize: 15,
    lineHeight: 1.5,
    marginTop: 0,
    marginBottom: 24
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 5
  },
  label: {
    color: '#000000',
    fontSize: 16
  }
})
